import { EMPTY_ARRAY } from '@app/constants/general';
import { useGetItemsCategoriesQuery } from '@app/hooks/queries/useGetItemsCategories';
import { ItemCategory } from '@app/hooks/queries/useGetItemsCategories/types';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export const useItemsCategories = () => {
  const { data = EMPTY_ARRAY as unknown as ItemCategory[] } = useGetItemsCategoriesQuery();

  const { formatMessage } = useIntl();

  return useMemo(
    () =>
      data
        .filter((c) => c.isActive)
        .map((category) => ({
          ...category,
          fullName: formatMessage({
            id: `global.product-categories.${category.slug}`,
            defaultMessage: category.name,
          }),
        })),
    [data, formatMessage]
  );
};

export default useItemsCategories;
